import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAuthService from '../../services/auth/authService';
import useLayoutService from '../../services/layout/layoutService';
import classes from './AdminGateLayout.module.css';

export default function AdminGateLayout() {
  const authService = useAuthService();
  const { isAuth, isAdmin } = useSelector((s) => s.auth);
  useLayoutService();

  useEffect(() => {
    authService.auth();
  }, []);

  useEffect(() => {
    if (isAuth || window.config?.autoLogin !== true) return;
    authService.accessRequest();
  }, [isAuth]);

  if (!isAuth) {
    return (
      <div className={classes.shell}>
        <div className={classes.center}>
          <div className={classes.cookieText}>
            {window.config?.nonAuthTextAdmin}
          </div>
          <button type="button" className={classes.cookieButton} onClick={() => authService.accessRequest()}>
            למתן הרשאה
          </button>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className={classes.shell}>
        <div className={classes.center}>
          <div className={classes.denyTitle}>אין לך הרשאה לממשק האדמין</div>
          <div className={classes.denyText}>
            הגישה למסך זה מוגבלת למנהלים בלבד. אם לדעתך אמורה להיות לך הרשאה,
            פנה למנהל המערכת.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.shell}>
      <Outlet />
    </div>
  );
}